import { Divider, Modal } from 'antd'
import React, { useState } from 'react'
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'
import TagSelectBox from '../../components/upload/TagSelectBox'
import { PackageInfo, PackType, Sticker, StickerCategory } from '../../types'
import ctgNameData from '../../data/ctgNameData'

import { getEmojinameByEmojiIndex } from '../../utils/findEmoji'
import { TrashIcon } from '../../components/CustomIcon'
import TagSearchInput from '../../components/upload/TagSearchInput'

import styles from '../../styles/TagSelectModal.module.css'
import '../../styles/tagSelect.css'
import SelectLangFormPlus from '../../components/upload/selectTag/SelectLangFormPlus'
import SelectLangFormBasic from '../../components/upload/selectTag/SelectLangFormBasic'
import SelectTagConfirm from '../../components/upload/selectTag/SelectTagConfirm'

export default function TagSelectForm({
  selectedSticker,
  packageAndSticker,
  everyStickerCategory,
  setSelectedSticker,
}: {
  selectedSticker: Sticker
  packageAndSticker: PackageInfo
  everyStickerCategory: StickerCategory[]
  setSelectedSticker: React.Dispatch<React.SetStateAction<Sticker | null>>
}) {
  const intl = useIntl()
  const packType: PackType | null = packageAndSticker.packType
  // console.log(selectedSticker)
  const stickerList = packageAndSticker.emoticons
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)

  //cagegory 전체 정보를 저장하기 위해 만듬
  const [selectedEmojiCategory, setSelectedEmojiCategory] =
    useState<StickerCategory | null>(null)

  const handleTextLangChange = (v: string) => {
    setSelectedSticker({ ...selectedSticker, textLang: v })
  }
  //emojicategory 에 null 인경우를 없앰
  const selectedCategory = selectedSticker.emojiCategories
    ? selectedSticker.emojiCategories
    : []
  // const [selectedCategory, setSelectedCategory] = useState<number[]>(
  //   selectedSticker.emojiCategories ? selectedSticker.emojiCategories : [],
  // )

  const addEmojiCategory = (emojiCategory: StickerCategory) => {
    if (selectedCategory.length >= 3) return
    if (selectedCategory.indexOf(emojiCategory.index) !== -1) return
    setSelectedEmojiCategory(emojiCategory)
  }
  // useEffect(() => {
  //   getIsOnEmojiCategories().then(r=>console.log(r))
  // }, [])
  const deleteTag = (deleteCategoryIndex: number) => {
    const newSelectedCategory = selectedCategory.filter(
      (index) => index !== deleteCategoryIndex,
    )
    setSelectedSticker({
      ...selectedSticker,
      emojiCategories: newSelectedCategory,
    })
  }

  return (
    <>
      <div style={{ margin: 'auto 35px' }}>
        {/* 모달 창 제목 */}
        <div className="tag-select-header-text">
          <FormattedMessage
            id={'SelectTag.modal.title'}
            defaultMessage={'Select tags and language'}
          />
        </div>
        <Divider />

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          <div>
            <div style={{ display: 'flex' }}>
              {/* 현재 선택된 스티커와 태그 확인 뷰*/}
              <div style={{ marginRight: 5 }}>
                <p className={styles.stickerHead} style={{}}>
                  <FormattedMessage
                    id="SelectTag.modal.sticker"
                    defaultMessage="Sticker"
                  />
                </p>
                <img
                  src={selectedSticker.origin}
                  width={170}
                  height={170}
                  style={{ border: '1px solid #ddd', borderRadius: 5 }}
                  alt="sticker_image"
                />
              </div>
              {/*선택한 이모지 리스트 뷰*/}
              <div className="selected-emoji-modal-items-wapper">
                <p className={styles.boldText} style={{ marginBottom: '8px' }}>
                  <FormattedMessage
                    id="SelectTag.modal.selectedTags"
                    defaultMessage="Selected tags"
                  />
                </p>
                {everyStickerCategory && (
                  <div className={styles.tagSelectList}>
                    {selectedCategory.map((category, index) => {
                      // console.log(category, everyStickerCategory)
                      const emojiData = getEmojinameByEmojiIndex(
                        category,
                        everyStickerCategory,
                      )
                      if (!emojiData) return null
                      // console.log(emojiData)
                      const emojiInfo = ctgNameData.find(
                        (data) => data.emoji === emojiData.emoji,
                      )
                      if (!emojiInfo) return null
                      // console.log(emojiInfo)
                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: 14,
                            margin: '3px 0px',
                          }}
                        >
                          <span
                            style={{
                              fontSize: 25,
                              fontFamily: 'NotoColorEmoji',
                            }}
                          >
                            {emojiInfo.emoji}{' '}
                          </span>
                          <span
                            style={{
                              width: '90%',
                              margin: '0px 15px',
                              color: '#323232',
                            }}
                          >
                            {intl.locale === 'ko'
                              ? emojiInfo.name_ko
                              : emojiInfo.name_en}
                          </span>
                          <div
                            className="selected-emoji-delete-btn"
                            onClick={() => {
                              deleteTag(category)
                            }}
                          >
                            <TrashIcon style={{ fontSize: 15 }} />
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
                {/* 선택된 이모지 리스트 보여주는 영역 */}
                <p
                  style={{
                    textAlign: 'end',
                    marginTop: 10,
                    fontSize: 12,
                    marginBottom: 0,
                  }}
                >
                  <span style={{ color: '#ff6060' }}>*</span>
                  <FormattedMessage
                    id="SelectTag.modal.maxTags"
                    defaultMessage="Maximum of 3 tags"
                  />
                </p>
              </div>
            </div>
            {/* 언어 선택 영역 */}
            <div style={{ marginTop: 22 }}>
              <p
                style={{ marginBottom: '4px' }}
                className={
                  intl.locale === 'en'
                    ? 'title-view-of-modal-title title-view-of-modal-title-en'
                    : 'title-view-of-modal-title'
                }
              >
                <FormattedMessage
                  id="SelectTag.modal.languageSelection.title"
                  defaultMessage="2. Language Selection"
                />
              </p>
              <p className="tag-selection-description lang-description">
                <FormattedMessage
                  id={`SelectTag.modal.languageSelection.description.${packType}`}
                  defaultMessage="If your sticker includes text in the image, select the language."
                />
              </p>
              {packageAndSticker.packType === 'PLUS' ? (
                <SelectLangFormPlus
                  // 플러스팩일 경우 textlang 이 무조건 있음
                  packageTextLang={packageAndSticker.textLang as string}
                  textLang={selectedSticker.textLang}
                  setTextLang={handleTextLangChange}
                />
              ) : (
                <SelectLangFormBasic
                  textLang={selectedSticker.textLang}
                  setTextLang={handleTextLangChange}
                />
              )}
            </div>
          </div>

          {/* 태그 선택 영역 */}
          <div className={styles.tagSelectSection}>
            <p
              style={{ marginBottom: '4px' }}
              className={
                intl.locale === 'en'
                  ? 'title-view-of-modal-title title-view-of-modal-title-en'
                  : 'title-view-of-modal-title'
              }
            >
              <FormattedMessage
                id="SelectTag.modal.tagSelection.title"
                defaultMessage="1. Tag Selection"
              />
            </p>
            <p className="tag-selection-description">
              <FormattedHTMLMessage
                id="SelectTag.modal.tagSelection.description"
                defaultMessage="Find appropriate tags for your sticker."
              />
            </p>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                margin: '30px 0px',
              }}
            >
              <div>
                <p
                  style={{
                    fontSize: 14,
                    lineHeight: '20px',
                    color: '#000',
                    marginBottom: 4,
                  }}
                  className={
                    intl.locale === 'en'
                      ? 'title-view-of-modal-title title-view-of-modal-title-en'
                      : 'title-view-of-modal-title'
                  }
                >
                  <FormattedMessage
                    id="SelectTag.modal.keywordSearch.title"
                    defaultMessage="Keyword Search"
                  />
                </p>
                <p className="tag-selection-description">
                  <FormattedHTMLMessage
                    id="SelectTag.modal.keywordSearch.description"
                    defaultMessage="What kind of words would you be saying when you use this sticker?"
                  />
                </p>
                {/* 검색으로 태그를 찾을 영역 */}
                {everyStickerCategory && (
                  <TagSearchInput
                    everyStickerCategory={everyStickerCategory}
                    selectedCategory={selectedCategory}
                    addEmojiCategory={addEmojiCategory}
                  />
                )}
              </div>
              <div style={{ color: '#000', margin: '21px 20px 0px 15px' }}>
                or
              </div>
              {everyStickerCategory && (
                <TagSelectBox
                  everyStickerCategory={everyStickerCategory}
                  selectedCategory={selectedCategory}
                  addEmojiCategory={addEmojiCategory}
                />
              )}
              {selectedEmojiCategory && (
                <Modal
                  className="tag-select-confirm-modal"
                  width={584}
                  visible={true}
                  footer={null}
                  onCancel={() => {
                    setSelectedEmojiCategory(null)
                    setSelectedSticker({
                      ...selectedSticker,
                      emojiCategories: [
                        ...selectedCategory,
                        selectedEmojiCategory.index,
                      ],
                    })
                  }}
                >
                  <SelectTagConfirm
                    selectedSticker={selectedSticker}
                    selectedEmojiCategory={selectedEmojiCategory}
                  />
                </Modal>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
